export default "__VITE_ASSET__e78c0c41__"